module.exports = __webpack_public_path__ + "static/media/exterior_back.bb463813.png";